module.exports = __webpack_public_path__ + "static/media/virtualfair.0a352dab.gif";